// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { X } from 'react-feather'

// CSS
import "./styles.scss"

class Filters extends Component {
  state = {
    visible: false
  }

  render() {
    const { title, filters, options, addFilter, removeFilter } = this.props
    const { visible } = this.state

    return (
      <div className="filters" >
        {filters.map(filter => (
          <div className="filters__filter" key={filter.value}>
            {filter.label}
            <X onClick={() => {
              removeFilter(filter)
              this.setState({ visible: false })
            }} />
          </div>
        ))}
        <div className="filters__add">
          <a onClick={() => this.setState({ visible: true })}>Adicionar Marcador</a>
          <div className={
            visible ?
              "filters__modal filters__modal--visible" :
              "filters__modal"
          }>
            <p className="filters__title">ESCOLHA O {title}</p>
            {options.map(option => (
              <div
                key={option.value}
                className="filters__option">
                <p>{option.label}</p>
                <ul>
                  {option.filters.map(filter => (
                    <li key={filter.value}
                      onClick={() => {
                        addFilter({ ...filter, option: option.value })
                        this.setState({ visible: false })
                      }}>
                      {filter.label}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default Filters
